type StorageKeys = 'USER_TOKEN';

export const getLocalStorageByKey = (Key: StorageKeys) => {
    return localStorage.getItem(Key);
}

export const setLocalStorage = (key: StorageKeys, value: string) => {
    localStorage.setItem(key, value);
}

export const deleteLocalStorage = (key: StorageKeys) => {
    localStorage.removeItem(key);
}